export class NgSelectListModel {
    value?: any;
    selectedText?: string;
    dropdownText?: string;
    default?: boolean;
    icon?: string;

    constructor(private newValue: any, private newSelectedText: string | undefined, private newDropdownText?: string, private newIcon?: string, newDefault?: boolean) {
        //had to do this or else the Json Converter to save and send the config file to the api does not recognize Boolean as a valid value for some reason.
        if (newValue === true) {
            this.value = true;
        } else if (newValue === false) {
            this.value = false;
        } else {
            this.value = newValue;
        }
        this.selectedText = newSelectedText;
        this.dropdownText = newDropdownText;
        this.default = newDefault;
        this.icon = newIcon;
    }
}
